module.exports = __webpack_public_path__ + "img/08.58b7c036.png";